import React, { useState, useEffect } from "react";
import CoreServices from "../components/CoreServices";
import LatestInnovations from "../components/LatestInnovations";
import StoryCard1 from "../StoryCards/StoryCard1";
import StoryCard2 from "../StoryCards/StoryCard2";
import StoryCard3 from "../StoryCards/StoryCard3";
import StoryCard4 from "../StoryCards/StoryCard4";
import { Link } from "react-router-dom";
import img3 from "../images/cropped-img5.jpg";
function Home() {
  const [text, setText] = useState("");
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const words = [
    "Artificial Intelligence",
    "Machine Learning",
    "Deep Learning",
    "Computer Vision",
    "Data Science",
  ];
  const [wordIndex, setWordIndex] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(150);

  useEffect(() => {
    const handleType = () => {
      const currentWord = words[wordIndex];

      if (isDeleting) {
        setText(currentWord.substring(0, text.length - 1));
        setTypingSpeed(50);
      } else {
        setText(currentWord.substring(0, text.length + 1));
        setTypingSpeed(150);
      }

      if (!isDeleting && text === currentWord) {
        setTimeout(() => setIsDeleting(true), 1000);
      } else if (isDeleting && text === "") {
        setIsDeleting(false);
        setWordIndex((wordIndex + 1) % words.length);
      }
    };

    const timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [text, isDeleting, wordIndex, words, typingSpeed]);

  return (
    <div className="main-body">
      <div className="WhyBharat" style={{ backgroundImage: `url(${img3})` }}>
        <ul>
          <li>
            <h1>
              <div>
                Empowering Tomorrow with{" "}
                <span className="typewriter"> {text}</span>
                <span className="cursor">|</span>
              </div>
            </h1>
            <h2>Smarter Solutions for a Smarter World</h2>

            <Link className="btn-explore" to="/explore-acetians/about-us">
              Explore Acetians
            </Link>
          </li>
        </ul>
      </div>

      <CoreServices />
      <LatestInnovations />
      <StoryCard3 />
      <StoryCard2 />
      <StoryCard1 />
      <StoryCard4 />
    </div>
  );
}

export default Home;
